module.exports = __webpack_public_path__ + "img/watchad.a77cbb59.png";